export default __webpack_public_path__ + "static/media/icon-studyconfig.00ff9e18.svg";